import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Typography,
} from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDeleteRoleMutation, useDeleteStageMutation } from '../../store/api/approvalApi'
import { usePostDeleteGroupMutation } from '../../store/api/groupApi'
import { useDeleteUserMutation } from '../../store/api/userApi'
import { hideDeleteDialog } from '../../store/slice/dialogSlice'
import { useDeleteVendorMutation } from '../../store/api/vendorApi'
import { offRefreshButton, onRefreshButton } from '../../store/slice/buttonSlice'
import { useDeleteRequestMutation } from '../../store/api/requestApi'
import { useDeleteBIDsMutation } from '../../store/api/bidsApi'
import { useDeleteRFQMutation } from '../../store/api/rfqsApi'
import { showErrorToast, showSuccessToast } from '../../constToast/constToast'
import { updateSelectedRFQsData } from '../../store/slice/rfqSlice'
import { useDeleteOrderMutation } from '../../store/api/orderApi'
import { useDeletePaymentMutation } from '../../store/api/paymentApi'
import { useDeleteRegisterInvoiceMutation } from '../../store/api/invoiceApi'
import { updateRefetchData } from '../../store/slice/otherSlice'

const DeleteDialog = ({ ids, callback }) => {
    const navigate = useNavigate()

    const open = useSelector((state) => state.dialogSlice.deleteDialog)
    const dispatch = useDispatch()
    const { dataId } = useParams()
    const handleClose = () => {
        dispatch(hideDeleteDialog())
    }

    const userData = useSelector((state) => state.mainToCard.userData)
    const groupData = useSelector((state) => state.mainToCard.groupData)
    const requestData = useSelector((state) => state.persistSlice.requestData)
    const vendorData = useSelector((state) => state.mainToCard.vendorData)
    const orderData = useSelector((state) => state.mainToCard.orderData)
    const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)
    const rfqsData = useSelector((state) => state.mainToCard.rfqsData)
    const bidsData = useSelector((state) => state.mainToCard.bidsData)
    const selectedRFQS = useSelector((state) => state.rfqSlice.selectedRFQs)
    const approvalRolesData = useSelector((state) => state.mainToCard.approvalRolesData)
    const approvalStageData = useSelector((state) => state.mainToCard.approvalStageData)
    const paymentCardDataSlice = useSelector((state) => state.paymentSlice.paymentCardDataSlice)
    const paymentData = useSelector((state) => state.persistSlice.paymentData)

    const paymentCardDataSliceHeader = paymentCardDataSlice?.header

    const [deleteUser] = useDeleteUserMutation()
    const [deleteGroup] = usePostDeleteGroupMutation()
    const [deleteOrder] = useDeleteOrderMutation()
    const [deleteApprovalRoles] = useDeleteRoleMutation()
    const [deleteApprovalStage, { isError: deleteStageError }] = useDeleteStageMutation()
    const [deleteVendor] = useDeleteVendorMutation()
    const [deleteRfq] = useDeleteRFQMutation()
    const [deleteRequest] = useDeleteRequestMutation()
    const [deletePayment] = useDeletePaymentMutation()
    const [deleteBIDs] = useDeleteBIDsMutation()
    const [deleteRegisterInvoice] = useDeleteRegisterInvoiceMutation()

    const handleRefresh = () => {
        dispatch(onRefreshButton())
        setTimeout(() => {
            dispatch(offRefreshButton(false))
        }, 1)
    }

    // let list;
    const deleteStageList = approvalStageData?.map((item) => item.id)

    useEffect(() => {
        deleteStageError &&
            toast.error(`Data can not be deleted`)
    }, [deleteStageError])

    let content, action
    const url = useLocation().pathname

    switch (url) {
        case '/groups':
            content = (
                <>
                    {groupData[0] ? (
                        <Typography component="span">Are you sure, you want to
                            delete {groupData[0]?.groupName} ?</Typography>
                    ) : (
                        <Typography component="span">User Groups not found</Typography>
                    )}
                </>
            )
            action = (
                groupData[0] ? <Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        deleteGroup({ groupIds: [groupData[0]?.groupId] })
                    }}
                >
                    Delete
                </Button> 
                : null
            )
            break
        case `/groups/${groupData[0]?.groupId}`:
            content = (
                <>
                    {groupData[0] ? (
                        <Typography component="span">Are you sure, you want to
                            delete {groupData[0]?.groupName} ?</Typography>
                    ) : (
                        <Typography component="span">Group not found</Typography>
                    )}
                </>
            )
            action = groupData[0] ? (
                <Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        deleteGroup({ groupIds: [groupData[0].groupId] })
                        navigate('/groups')
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/users':
            content = (
                <>
                    {userData[0] && userData[0].userName ? (
                        <Typography component="span">Are you sure, you want to
                            delete {userData[0].userName} ?</Typography>
                    ) : (
                        <Typography component="span">User not found</Typography>
                    )}
                </>
            )
            action = userData[0] ? (
                <Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        deleteUser({ userIds: [userData[0]?.id] })
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/requests':
            content = (
                <>
                    {requestData && requestData?.[0] && requestData?.[0]?.requestMainId ? (
                        <Typography component="span">Are you sure, you want to
                            delete {requestData?.[0]?.requestNo}?</Typography>
                    ) : (
                        <Typography component="span">Request not found</Typography>
                    )}
                </>
            )
            action = requestData?.[0] ? (
                <Button
                    variant="contained"
                    onClick={async () => {
                      const requestDeleteIds = requestData?.map((item) => item.requestMainId)
                      const data = await deleteRequest(requestDeleteIds)
                        if (data?.data?.statusCode === 200) {
                            showSuccessToast('Succesfully')
                        }
                        handleClose()
                        handleRefresh()
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/payment':
            content = (
                <>
                    {paymentData && paymentData?.[0] && paymentData?.[0]?.paymentDocumentMainId ? (
                        <Typography component="span">
                            Are you sure, you want to
                            delete {paymentData?.map((item) => item.paymentRequestNo).join(', ')}?
                        </Typography>
                    ) : (
                        <Typography component="span">Request not found</Typography>
                    )}
                </>
            )
            action = paymentData?.[0] ? (
                <Button
                    variant="contained"
                    onClick={async () => {
                        const paymentDocumentMainIds = paymentData?.map((item) => item.paymentDocumentMainId)
                        const data = await deletePayment({ paymentDocumentMainIds })

                        if (data?.data?.statusCode === 200) {
                            showSuccessToast('Succesfully')
                        }
                        handleClose()
                        handleRefresh()
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case `/payment/${dataId}`:
            content = (
                <>
                    {paymentCardDataSliceHeader?.paymentDocumentMainId ? (
                        <Typography component="span">
                            Are you sure, you want to delete {paymentCardDataSliceHeader?.paymentRequestNo}?
                        </Typography>
                    ) : (
                        <Typography component="span">Request not found</Typography>
                    )}
                </>
            )
            action = paymentCardDataSliceHeader?.paymentDocumentMainId ? (
                <Button
                    variant="contained"
                    onClick={async () => {
                        try {
                            const data = await deletePayment({
                                paymentDocumentMainIds: [paymentCardDataSliceHeader?.paymentDocumentMainId ?? 0],
                            })

                            if (data?.data?.statusCode === 200) {
                                showSuccessToast(`${paymentCardDataSliceHeader?.paymentRequestNo} Successfully deleted`)
                                handleClose()
                                handleRefresh()
                                navigate('/payment')
                                return
                            }

                            showErrorToast(`Error deleting bidNo: ${paymentCardDataSliceHeader?.paymentRequestNo}`)
                            handleClose()
                            handleRefresh()
                        } catch (error) {
                            console.error('Message:', error)
                            showErrorToast(`Error deleting bidNo: ${paymentCardDataSliceHeader?.paymentRequestNo}`)
                            showErrorToast('Error')
                        }
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/bids':
            content = (
                <Typography component="span">
                    {bidsData?.id ? `Are you sure, you want to delete: ${bidsData?.row?.bidNo} ?` : 'BID not found'}
                </Typography>
            )

            action = bidsData ? (
                <Button
                    variant="contained"
                    onClick={async () => {
                        try {
                            const response = await deleteBIDs(bidsData?.row?.bidMainId)
                            if (response?.data?.statusCode === 200) {
                                showSuccessToast(`${bidsData?.row?.bidNo} Successfully deleted`)
                                return
                            }

                            showErrorToast(`Error deleting bidNo: ${bidsData?.row?.bidNo}`)
                        } catch (error) {
                            console.error('Error deleting bid:', error)
                            showErrorToast(`Error deleting bidNo: ${bidsData?.row?.bidNo}`)
                        } finally {
                            handleClose()
                            handleRefresh()
                        }
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case `/requests/${requestData?.[0]?.requestMainId}`:
            content = (
                <>
                    {requestData && requestData?.[0] && requestData?.[0]?.requestMainId ? (
                        <Typography component="span">Are you sure, you want to
                            delete {requestData?.[0]?.requestNo}?</Typography>
                    ) : (
                        <Typography component="span">Request not found</Typography>
                    )}
                </>
            )
            action = requestData[0] ? (
                <Button
                    variant="contained"
                    onClick={async () => {
                        const data = await deleteRequest(requestData && requestData?.[0]?.requestMainId)
                        if (data?.data?.statusCode === 200) {
                            showSuccessToast('Succesfully')
                        }
                        handleClose()
                        handleRefresh()
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/approval-roles':
            content = (
                <>
                    {approvalRolesData[0] && approvalRolesData[0].approveRoleName && approvalRolesData[0].approveRoleId > 0 ? (
                        <Typography component="span">
                            Are you sure, you want to delete {approvalRolesData[0].approveRoleName} ?
                        </Typography>
                    ) : (
                        <Typography component="span">The newly added information is deleted</Typography>
                    )}
                </>
            )

            action = approvalRolesData[0]?.approveRoleId > 0 && (
                <Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        approvalRolesData[0].approveRoleId > 0 &&
                            deleteApprovalRoles({
                                roleIds: [approvalRolesData[0].approveRoleId],
                            })
                    }}
                >
                    Delete
                </Button>
            )
            break
        case '/approval-stages':
            content = (
                <>
                    {approvalStageData.length > 0 ? (
                        <Typography component="span">
                            Are you sure, you want to delete{' '}
                            {approvalStageData.length > 1 ? 'Stages' : approvalStageData[0].approveStageName} ?
                        </Typography>
                    ) : (
                        <Typography component="span">Data Can not be deleted</Typography>
                    )}
                </>
            )
            action = (
                approvalStageData.length > 0 &&
                <Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        deleteApprovalStage({
                            stageIds: deleteStageList,
                        })
                    }}
                >
                    Delete
                </Button>
            )
            break
        case '/vendors':
            content = (
                <>
                    {vendorData[0] && vendorData[0]?.vendorCode ? (
                        <Typography component="span">Are you sure, you want to
                            delete {vendorData[0]?.vendorCode} ?</Typography>
                    ) : (
                        <Typography component="span">Vendor not found</Typography>
                    )}
                </>
            )
            action = vendorData[0] ? (
                <Button
                    Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        handleRefresh()
                        deleteVendor({ ids: [vendorData[0]?.vendorId] })
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/orders':
            content = (
                <>
                    {orderData[0] && orderData?.map(x => x.orderNo).join(', ') ? (
                        <Typography component="span">Are you sure, you want to
                            delete {orderData?.map(x => x.orderNo).join(', ')} ?</Typography>
                    ) : (
                        <Typography component="span">Order not found</Typography>
                    )}
                </>
            )

            action = orderData[0] ? (
                <Button
                    variant="contained"
                    onClick={() => {
                        handleClose()
                        dispatch(updateRefetchData())
                        deleteOrder(orderData?.map(x => x.orderMainId))
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        case '/rfqs':
            content = (
                <>
                    {selectedRFQS?.length || (rfqsData[0] && rfqsData[0]?.id && localStorage.getItem('rfqTabValue') == 2) ? (
                        <Typography component="span">
                            Are you sure, you want to delete{' '}
                            {selectedRFQS?.length ? `${selectedRFQS.length} RFQ(s)` : rfqsData[0]?.rfqNo} ?
                        </Typography>
                    ) : (
                        <Typography component="span">
                            {localStorage.getItem('rfqTabValue') != 2 ? 'RFQ can not be deleted!' : 'RFQ not found'}
                        </Typography>
                    )}
                </>
            )
            action = (selectedRFQS?.length ||
                (rfqsData[0] && rfqsData[0]?.id && localStorage.getItem('rfqTabValue') == 2)) && (
                    <Button
                        variant="contained"
                        onClick={async () => {
                            handleClose()
                            handleRefresh()
                            const data = await deleteRfq({ rfqMainId: selectedRFQS?.length ? selectedRFQS : [rfqsData[0].id] })
                            if (data?.data?.statusCode === 200) {
                                showSuccessToast('Successfully Deleted')
                            }
                            dispatch(updateSelectedRFQsData([]))
                        }}
                    >
                        Delete
                    </Button>
                )
            break
        case `/rfqs/${dataId}`:
            content = (
                <>
                    {rfqsData?.[0]?.status == 0 && dataId > 0 ? (
                        <Typography component="span">Are you sure, you want to
                            delete {rfqsData?.[0]?.rfqNo} ?</Typography>
                    ) : (
                        <Typography
                            component="span">{dataId == 0 ? 'RFQ not found' : 'RFQ can not be deleted!'}</Typography>
                    )}
                </>
            )
            action = (
                <>
                    {rfqsData?.[0]?.status == 0 && dataId > 0 && (
                        <Button
                            variant="contained"
                            onClick={async () => {
                                handleClose()
                                handleRefresh()
                                navigate('/rfqs')
                                const data = await deleteRfq({ rfqMainId: [dataId] })
                                if (data?.data?.statusCode === 200) {
                                    showSuccessToast('Successfully Deleted')
                                }
                                dispatch(updateSelectedRFQsData([]))
                            }}
                        >
                            Delete
                        </Button>
                    )}
                </>
            )
            break

        case '/invoice-register':
            content = (
                <>
                    {invoiceMain[0] ? (
                        <Typography component="span">
                            Are you sure, you want to delete{' '}
                            <span style={{ fontWeight: 'bold', color: 'black' }}>
                                Invoice No: {invoiceMain[0].invoiceNo}
                            </span>
                            {' ?'}
                        </Typography>
                    ) : (
                        <Typography component="span">Invoice not found</Typography>
                    )}
                </>
            )
            action = invoiceMain[0] ? (
                <Button
                    variant="contained"
                    onClick={async () => {
                        handleClose()
                        handleRefresh()
                        const data = await deleteRegisterInvoice([invoiceMain[0]?.invoiceRegisterId])
                        if (data?.data?.statusCode === 200) {
                            showSuccessToast(`${invoiceMain[0]?.invoiceNo} deleted`)
                        } else {
                            showErrorToast('Error')
                        }
                    }}
                >
                    Delete
                </Button>
            ) : (
                <></>
            )
            break
        default:
            content = null
            break
    }
    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Delete</DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText>{content}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    {action}
                    <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default DeleteDialog